import styled from 'styled-components';

import footerHeight from '../../constants/footer.constant';

type ScrollProps = {
  scrollPosition?: number;
};

const getBottom = (scrollPosition?: number) => {
  if (scrollPosition === undefined) {
    return document.body.scrollHeight > window.innerHeight
      ? `-${footerHeight}px`
      : '0px';
  }

  if (scrollPosition >= footerHeight) {
    return `-${footerHeight}px`;
  }

  return `${-scrollPosition}px`;
};

export const Content = styled.footer<ScrollProps>`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${footerHeight}px;
  bottom: ${p => getBottom(p.scrollPosition)};
  background-color: #e7e7e7;
`;

export const Version = styled.div``;
